import { ConnectionState } from '@nemuru-eng/js-api-client';

import { setPageStateById } from '../PageContext';

export const setLiveState = (setState: setPageStateById) => (liveState: ConnectionState) => {
  setState('SET_LIVE_STATE', (s) => ({
    ...s,
    liveState,
  }));
};
